import React from 'react';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import { GroupWrapper } from 'src/components/profileComponents/Marketplace/components/GroupWrapper';
import { translations } from 'src/constants/translations';
import { BoxFormTextField } from 'src/components/profileComponents/FormTextField';
import { BoxFormAutocomplete } from 'src/components/profileComponents/FormAutocomplete';
import { IOSSwitch } from 'src/components/SwitchIos';
import {
  accordionStateOptions, AccordionStateType,
  IMarketplaceFilterRange, IMarketplaceProperty,
} from 'src/components/profileComponents/Marketplace/types';
import {
  IDevelopmentSpecificationPropChange,
} from 'src/components/profileComponents/Complexes/components/ProjectSpecification/types';
import { updateTranslatedField } from 'src/components/profileComponents/Marketplace/components/Filters/helpers';
import {
  GroupWrapperFiltersAction,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction';
import { InfoTag } from 'src/components/profileComponents/Marketplace/components/Filters/components/InfoTag';
import { useStyles } from './styles';

interface IRangeProps {
  item: IMarketplaceFilterRange,
  lang: string,
  propertyOptions: IDevelopmentSpecificationPropChange<IMarketplaceProperty>[]
  onTrash: () => void,
  onChange: (item: IMarketplaceFilterRange) => void,
}

export const Range: React.FC<IRangeProps> = ({
  item, lang, propertyOptions, onTrash, onChange,
}) => {
  const styles = useStyles();
  return (
    <>
      <GroupWrapper
        name="Range"
        startIcon={<LabelOutlinedIcon />}
        actions={(
          <GroupWrapperFiltersAction
            onTrash={onTrash}
            onDrag={() => {}}
          />
        )}
      >
        <div className={styles.rangeWrapper}>
          <BoxFormTextField
            label={translations.name}
            name="name"
            defaultValue={item.name?.[lang]}
            onChange={(event) => {
              onChange(updateTranslatedField(item, 'name', lang, event.target.value));
            }}
          />
          <BoxFormTextField
            label={translations.fromNaming}
            name="from"
            defaultValue={item.fromName?.[lang]}
            onChange={(event) => {
              onChange(updateTranslatedField(item, 'fromName', lang, event.target.value));
            }}
          />
          <BoxFormTextField
            label={translations.toNaming}
            name="to"
            defaultValue={item.toName?.[lang]}
            onChange={(event) => {
              onChange(updateTranslatedField(item, 'toName', lang, event.target.value));
            }}
          />
          <BoxFormAutocomplete
            label={translations.chooseProperty}
            name="property"
            defaultValue={{ label: item.property?.translates?.[lang] || item.property?.systemName, value: item.property }}
            onChange={(event: IDevelopmentSpecificationPropChange<IMarketplaceProperty>) => {
              onChange({ ...item, property: event.value });
            }}
            options={propertyOptions}
          />

          <BoxFormAutocomplete
            label={translations.accordionState}
            name="accordionState"
            defaultValue={{ label: item.accordionState, value: item.accordionState }}
            options={accordionStateOptions}
            onChange={(event: {label: string, value: AccordionStateType}) => {
              onChange({ ...item, accordionState: event.value });
            }}
          />
        </div>
        <div className={styles.subRangeWrapper}>
          <div>
            <div className={styles.subRangeSwitch}>
              <IOSSwitch name="checkedInfrastructure" />
            </div>
          </div>
          <BoxFormTextField
            label={translations.mainUOM}
            name="mainUOM"
            defaultValue={item.mainUom?.[lang]}
            onChange={(event) => {
              onChange(updateTranslatedField(item, 'mainUom', lang, event.target.value));
            }}
          />
          <BoxFormTextField
            label={translations.secondaryUOM}
            name="secondaryUOM"
            defaultValue={item.secondaryUom?.[lang]}
            onChange={(event) => {
              onChange(updateTranslatedField(item, 'secondaryUom', lang, event.target.value));
            }}
          />
          <BoxFormTextField
            label={translations.conversionRate}
            name="conversionRate"
            defaultValue={String(item?.uomRate || '')}
            onChange={(event) => {
              onChange({ ...item, uomRate: Number(event.target.value) });
            }}
          />
        </div>
        <InfoTag
          item={item.tooltip}
          lang={lang}
          onChange={(tooltip) => onChange({ ...item, tooltip })}
        />
      </GroupWrapper>
    </>
  );
};
